import React from 'react';
import PropTypes from 'prop-types';

import { ENTRY_TYPES } from '../../../models/GlossaryText';
import { GlossaryModal } from '../glossary-modal';
import styles from './GlossaryLink.css';

const IPropTypes = {
  className: PropTypes.string,
  entry: PropTypes.shape({
    entryType: PropTypes.oneOf(Object.values(ENTRY_TYPES)).isRequired,
    index: PropTypes.number.isRequired,
    text: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
  }).isRequired,
};

const defaultProps = {
  className: '',
};

class GlossaryLink extends React.Component {
  /*
    React removes whitespace at the beginning of lines, so we need to
    force it to appear using the special character.
  */
  static renderNecessaryWhitespace(text) {
    const spaceRegex = /^\s+/;
    const match = spaceRegex.exec(text);
    if (match) {
      return match[0].split('').map(() => '\u00A0');
    }
    return '';
  }

  constructor(props) {
    super(props);

    this.state = {
      clicked: false,
    };

    this._toggleModal = this._toggleModal.bind(this);
  }

  _toggleModal() {
    this.setState(prevState => ({
      clicked: !prevState.clicked,
    }));
  }

  render() {
    const { entry } = this.props;
    if (entry.entryType === ENTRY_TYPES.PLAIN_TEXT) {
      return (
        <span className={this.props.className}>
          {entry.text}
        </span>
      );
    } else if (entry.entryType === ENTRY_TYPES.EXTERNAL_LINK) {
      const protocolRegex = /^https?:\/\//;
      let link = entry.value;
      if (link.search(protocolRegex) === -1) {
        link = `https://${link}`;
      }
      return (
        <React.Fragment>
          {GlossaryLink.renderNecessaryWhitespace(entry.text)}
          <a
            className={[styles.link, this.props.className].join(' ')}
            href={link}
            target="_blank"
            rel="noopener noreferrer"
          >
            {entry.text}
          </a>
        </React.Fragment>
      );
    } else if (entry.entryType === ENTRY_TYPES.DEFINITION ||
        entry.entryType === ENTRY_TYPES.IMAGE) {
      return (
        <React.Fragment>
          {GlossaryLink.renderNecessaryWhitespace(entry.text)}
          <button
            className={[styles.buttonLink, this.props.className].join(' ')}
            onClick={this._toggleModal}
          >
            {entry.text.trim()}
          </button>
          {
            this.state.clicked &&
            <GlossaryModal
              entryType={entry.entryType}
              onClose={this._toggleModal}
              value={entry.value}
            />
          }
        </React.Fragment>
      );
    }
    return null;
  }
}

GlossaryLink.propTypes = IPropTypes;
GlossaryLink.defaultProps = defaultProps;

export { GlossaryLink };



// WEBPACK FOOTER //
// ./src/common/glossary-entry/glossary-link/GlossaryLink.jsx